import { ChangeDetectionStrategy, Component, forwardRef, input, output, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MaskitoOptions } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
import { MaskitoDirective } from '@maskito/angular';
import { InputSize } from '../../../enum/input-size.enum';

@Component({
  selector: 'lib-rate-input',
  imports: [MatIcon, MaskitoDirective],
  templateUrl: './rate-input.component.html',
  styleUrl: './rate-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RateInputComponent),
      multi: true,
    },
  ],
})
export class RateInputComponent implements ControlValueAccessor {
  placeholder = input<string>('');
  autocomplete = input<string>('');
  controlId = input<string | null>(null);
  error = input<boolean>(false);
  inputSize = input<InputSize>(InputSize.large);
  allowNegative = input<boolean>(false);
  valueChange = output<string | null>();

  // TODO: these need to be passed in
  protected readonly maskitoOptions: MaskitoOptions = maskitoNumberOptionsGenerator({
    decimalSeparator: '.',
    min: this.allowNegative() ? -100 : 0,
    max: 100,
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });

  protected readonly InputSize = InputSize;

  public value = signal<string | null>(null);
  public disabled = signal(false);

  public writeValue(value: string | null): void {
    this.value.set(value);
  }

  public registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public handleInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.value.set(inputValue);
    this.valueChange.emit(inputValue);
    this.onChange(inputValue);
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  private onChange: (value: string | null) => void = () => {
    // default onChange
  };
  private onTouched: () => void = () => {
    // default onTouched
  };
}
